export enum FormPosition {
  LEFT = 'position-left',
  CENTER = 'position-center',
}
